import { MDSSessionContentStatic } from "./session-content-static";
import { MDSSessionContentDynamic } from "./session-content-dynamic";
import { useSessionFeature } from "../session-context";
import { IMDSSessionProps, SessionFeature } from "../session.types";

export const MDSSessionContent = (props: IMDSSessionProps) => {
  const isDynamicViewEnabled = useSessionFeature(SessionFeature.DynamicView);

  // If DynamicView feature is enabled, use the dynamic content component
  if (isDynamicViewEnabled) {
    return <MDSSessionContentDynamic {...props} />;
  }

  return <MDSSessionContentStatic {...props} />;
};
